import { Expose, Type } from 'class-transformer';
import { BaseModel } from '@core/data-access';

export class CpfEmployerHistoryModel extends BaseModel {
  @Expose() month!: string;
  @Expose() employer!: string;
}

/** Provenance MyInfo answered the group with — echoed back unchanged, never edited. */
export class CpfEmployerModel extends BaseModel {
  @Expose()
  classification?: string;

  @Expose()
  @Type(() => CpfEmployerHistoryModel)
  history?: CpfEmployerHistoryModel[];

  @Expose()
  lastUpdated?: string;

  @Expose()
  lastUpdatedOnly?: string;

  @Expose()
  source?: string;
}
